import { useNavigate } from 'react-router-dom';

import RetireCard from 'components/retire-card/retire-card';
import { ButtonsPosition, Button } from 'components/common/button/button';

import {
  CERTIFICATES_PAGE,
  RETIRE_ACTIVITY_PAGE
} from 'site-settings/site-navigation';

import { Wrapper } from 'assets/styles/pages.style';

const RetirePage = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <ButtonsPosition position="right">
        <Button
          variant="outlined"
          size="middle"
          fullwidth
          onClick={() => navigate(CERTIFICATES_PAGE)}
        >
          Retirement Certificates
        </Button>
        <Button
          variant="outlined"
          size="middle"
          fullwidth
          onClick={() => navigate(RETIRE_ACTIVITY_PAGE)}
        >
          Retirement Activity
        </Button>
      </ButtonsPosition>
      <RetireCard />
    </Wrapper>
  );
};

export default RetirePage;
